import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, IconButton, DialogContent, TextField, Alert, Autocomplete, Box, Typography, Chip, Button, Collapse, Select, MenuItem } from '@mui/material';
import { CloseSquare, Filter } from 'iconsax-react';

const FiltersModal = ({ show, setShow, uiStore, searchFilters, updateFilters, contacts = true, selectedProfile, previousFilters, clear, cardOptions, setSelectedProfile }) => {
    const { error } = uiStore
    const [filters, setFilters] = useState([]);
    const [advanced, setAdvanced] = useState(false);

    useEffect(() => {

        async function initFilters() {
            var filters = [];

            if (contacts) {
                filters = [{
                    name: "Show Contacts",
                    value: selectedProfile !== 'All Cards' ? ["n'Sync"] : previousFilters?.length ? previousFilters[0].value : ["All"],
                    type: "single",
                    options: ["All", "n'Sync", 'Following'],
                    advanced: false
                },
                {
                    name: "Tags",
                    value: [],
                    type: "multiple",
                    options: [],
                    advanced: false
                }]
            }

            filters = [
                ...filters,
                { name: "Company", value: [], type: "select", options: [], advanced: false },
                { name: "Country", value: [], type: "select", options: [], advanced: false },
                { name: "State / Province", value: [], type: "select", options: [], advanced: true },
                { name: "City", value: [], type: "select", options: [], advanced: true },
                { name: "Job Title", value: [], type: "select", options: [], advanced: true },
                { name: "Department", value: [], type: "select", options: [], advanced: true },
            ];

            if (contacts) {
                const data = await uiStore.getContactsFilters();

                for (let i = contacts ? 1 : 0; i < filters.length; i++) {
                    filters[i].options = [...filters[i].options]
                    data[filters[i].name].forEach((info) => {
                        if (filters[i].name === 'Tags') {
                            filters[i].options = [...filters[i].options, info]
                        } else if (filters[i].name === "Country") {
                            if (info && !filters[i].options.includes(info)) filters[i].options = [...filters[i].options, info];
                        } else if (filters[i].name === "State / Province") {
                            if (info && !filters[i].options.includes(info)) filters[i].options = [...filters[i].options, info];
                        } else if (filters[i].name === "City") {
                            if (info && !filters[i].options.includes(info)) filters[i].options = [...filters[i].options, info];
                        } else {
                            if (info.multipleValues) {
                                info.infoValues.forEach(item => {
                                    if (!filters[i].options.includes(item))
                                        filters[i].options.push(item);
                                })
                            } else {
                                if (!filters[i].options.includes(info.infoValue))
                                    filters[i].options.push(info.infoValue);
                            }
                        }
                    });
                }
                setFilters(filters);

            } else {
                for (let i = 0; i < filters.length; i++) {
                    filters[i].options = [...filters[i].options]

                    searchFilters[filters[i].name]?.forEach((info) => {
                        if (filters[i].name === 'Tags') {
                            filters[i].options = [...filters[i].options, info]
                        } else if (filters[i].name === 'Social Network') {
                            filters[i].options = [...filters[i].options, info];
                        } else {
                            if (info.multipleValues) {
                                info.infoValues.forEach(item => {
                                    if (!filters[i].options.includes(item))
                                        filters[i].options.push(item);
                                })
                            } else {
                                if (!filters[i].options.includes(info.infoValue))
                                    filters[i].options.push(info.infoValue);
                            }
                        }
                    });
                }
                setFilters(filters);
            }
        }

        initFilters();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contacts, selectedProfile, searchFilters]);

    const handleChangeFilter = (filterName, value) => {
        const index = filters.findIndex(filter => filter.name === filterName);
        const clone = JSON.parse(JSON.stringify(filters));

        if (clone[index])
            clone[index].value = value;
        setFilters(clone);
        updateFilters(clone);
    }

    const clearFilters = () => {
        const clone = [...filters];
        clone.forEach(element => {
            element.value = [];
        });

        if (contacts)
            clone[0]['value'] = ['All'];
        setFilters(clone);
        updateFilters(clone, true);
        if (clear)
            clear();
    };

    return (
        <Dialog
            open={show}
            onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            fullWidth
            maxWidth='xs'
        >
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {error &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }} >
                    <Box sx={{ display: 'flex' }}>
                        <Filter
                            size="24"
                            variant="Bulk"
                        />
                        <Typography fontWeight={600} sx={{ ml: 1 }}>Filters</Typography>
                    </Box>
                    <Button fontSize={14} onClick={clearFilters}>CLEAR</Button>
                </Box>
                <Box>
                    <Select
                        size='small'
                        value={selectedProfile}
                        onChange={(e) => setSelectedProfile(e.target.value)}
                        sx={{ borderRadius: 50, backgroundColor: 'rgb(227, 232, 239)', mt: 2.5 }}
                        fullWidth
                    >
                        {cardOptions?.map((i) =>
                            <MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>
                        )}
                    </Select>
                </Box>

                <Box sx={{ mt: 3 }}>

                    {filters?.filter(i => !i.advanced)?.map(filter =>
                        <Box key={filter.name}>
                            {filter.type === 'single' &&
                                <>
                                    <Typography fontWeight={600} fontSize='14px'>Show Contacts</Typography>
                                    <Chip
                                        variant={filter.value.includes('All') ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label='All'
                                        onClick={() => handleChangeFilter(filter.name, ['All'])}
                                    />
                                    <Chip
                                        variant={filter.value.includes("n'Sync") ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label="n'Sync"
                                        onClick={() => handleChangeFilter(filter.name, ["n'Sync"])}
                                    />
                                    <Chip
                                        variant={filter.value.includes('Following') ? "contained" : 'outlined'}
                                        color='greyPrimary' sx={{ mr: 1, mt: 1 }} label='Added'
                                        onClick={() => handleChangeFilter(filter.name, ['Following'])}
                                    />
                                </>
                            }

                            {filter.type === 'multiple' &&
                                <Autocomplete
                                    multiple
                                    sx={{ mt: 3 }}
                                    renderInput={(params) => <TextField label='Tags' {...params} />}
                                    disablePortal
                                    options={filter.options}
                                    size='small'
                                    onChange={(e, value) => handleChangeFilter(filter.name, value)}
                                    value={filter.value}
                                />
                            }

                            {filter.type === 'select' &&
                                <Autocomplete
                                    sx={{ mt: 3 }}
                                    renderInput={(params) => <TextField label={filter.name} {...params} />}
                                    disablePortal
                                    options={filter.options}
                                    size='small'
                                    onChange={(e, value) => handleChangeFilter(filter.name, [value])}
                                    value={filter.value[0]}
                                />
                            }

                        </Box>
                    )}

                    <Collapse in={advanced}>
                        {filters?.filter(i => i.advanced)?.map(filter =>
                            <Autocomplete
                                key={filter.name}
                                sx={{ mt: 3 }}
                                renderInput={(params) => <TextField label={filter.name} {...params} />}
                                disablePortal
                                options={filter.options}
                                size='small'
                                onChange={(e, value) => handleChangeFilter(filter.name, [value])}
                                value={filter.value[0]}
                            />
                        )}
                    </Collapse>

                </Box>


                <Box sx={{ mt: 3 }}>
                    <Button onClick={() => setAdvanced(val => !val)} fontSize={14}> {!advanced ? 'Show Advanced' : 'Hide Advanced'}</Button>
                </Box>

            </DialogContent>
        </Dialog>
    );
};

export default FiltersModal;